import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import Select from "../../../../components/Select";

export default function NumberOfDependants({ searchObject, onChange, t }) {
  const [numberOfDependants, setNumberOfDependants] = useState([]);

  useEffect(() => {
    CommonService.getNumberOfDependats().then((data) =>
      setNumberOfDependants(data)
    );
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Nº of dependants")}</legend>
      <Select
        name="numberOfDependantId"
        value={searchObject.numberOfDependantId || ""}
        onChange={onChange}
        className="form-select fontsize-legend"
      >
        <option value=""></option>
        {numberOfDependants.map((numberOFdependant) => (
          <option
            className="fontsize-legend"
            value={numberOFdependant.id}
            key={numberOFdependant.id}
          >
            {t(numberOFdependant.description)}
          </option>
        ))}
      </Select>
    </div>
  );
}
